import type { Strings } from "@/app/i18n/strings";
import { ApiError } from "@/services/ApiClient";

/** Turns a failed API call into the sentence shown under the form. */
export function describeError(error: unknown, t: Strings): string {
  if (error instanceof ApiError) {
    switch (error.code) {
      case "invalid_email": return t.account.errors.invalidEmail;
      case "too_soon":
      case "rate_limited": return t.account.errors.tooSoon;
      case "wrong_code": return t.account.errors.wrongCode;
      case "code_gone": return t.account.errors.codeGone;
      case "email_required": return t.account.errors.emailRequired;
      case "invalid_handoff": return t.account.errors.authFailed;
    }
  }
  return t.account.errors.network;
}
